var _rect, _path, _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastSuccessV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "toast-success-v2_svg__a)",
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#" + _uid + "toast-success-v2_svg__b)",
    strokeWidth: 0.5,
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25Z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 6,
    fill: "#fff",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00C553",
    d: "M12 6a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6m2.634 4.942-3.23 3.23a.464.464 0 0 1-.654 0l-1.384-1.384a.462.462 0 0 1 .653-.653l1.058 1.059 2.904-2.905a.461.461 0 1 1 .653.653"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-success-v2_svg__a",
    x1: -0.951,
    x2: 12,
    y1: -24.333,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C553"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3C"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-success-v2_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F69"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })))));
};
export { SvgToastSuccessV2 as ReactComponent };
export default __webpack_public_path__ + "8443ab966896a731d00c31c35e345d2f.svg";